import React from 'react';
import { AdminDashboard } from '../components/admin';
import './pages.css';

const AdminPage: React.FC = () => {
  return <AdminDashboard />;
};

export default AdminPage;